export const filterNames = {
  masters: 'masters',
  executers: 'executers',
  parentServices: 'parentServices',
  services: 'services',
  statuses: 'statuses',
  doneDate: 'doneDate',
  cities: 'cities',
  regions: 'regions',
  streets: 'streets',
  houses: 'houses',
  flats: 'flats',
  marks: 'marks',
  ratings: 'ratings',
  statusChangePeriod: 'statusChangePeriod',
  createDate: 'createDate',
  expired: 'expired',
  hasAddress: 'hasAddress',
  companies: 'companies',
  expiredPeriod: 'expiredPeriod',
  creationMethods: 'creationMethods',
  priorities: 'priorities',
  createUsers: 'createUsers',
  applicants: 'applicants',
  addressStagesLifeCycle: 'addressStagesLifeCycle',
};
